export class ElcProductionReporting {
    constructor() {
        $("#elc_production_entry_report_qty").on("input", ()=> {
            this.report_production();
        });
    }

    report_production() {
        let reporedtQty = $("#elc_production_entry_report_qty").val().toString();
        $('#error-message').text('');
        let prevAfterInputValue = $('#production_new_current_percentage').data('current');
        if(parseFloat(reporedtQty) >= 0)
        {
            let expectedQty = $("#expected_qty_since_last_report").text();
            let PrevReportedQty = parseInt($("#last_reported_qty").data("prev-actual-qty"));
            let PrevExpectedQty = ($("#expected_qty_since_last_report").data("prev-expected-qty"));
            let currentTotalReportedQty = parseInt($("#modal_current_reported_qty").data("current-quantity"));
            let currentTotalExpectedQty = parseInt($("#modal_current_reported_qty").data("expected-quantity"));
            var result
            $("#last_reported_qty").text((parseFloat(reporedtQty) - currentTotalReportedQty).toFixed(0));
            result = (parseFloat(reporedtQty) - currentTotalReportedQty) - parseFloat(expectedQty);
            $("#qty_under_over_produced").text(result.toFixed(0));
            if(parseFloat(expectedQty) == 0.0)
                result = 0
            else
                result = (((parseFloat(reporedtQty) - currentTotalReportedQty)/ parseFloat(expectedQty)) * 100);
            if(((result <= 95) ||(result >= 105)) && (result !=0))
                $('#elc_production_entry_variance_reason').attr('required','required');
            else
                $('#elc_production_entry_variance_reason').removeAttr('required');
            $("#current_percentage_since_last_report").text(result.toFixed(2) + "%");
            if(((currentTotalExpectedQty + parseFloat(expectedQty)) == 0) || (parseFloat(reporedtQty) == 0.0))
                result = 0;
            else
                result = (parseFloat(reporedtQty) / (currentTotalExpectedQty + parseFloat(expectedQty))) * 100;
            $("#production_new_current_percentage").text(result.toFixed(2)+'%');
        }
        else if(reporedtQty && parseFloat(reporedtQty) < 0)
        {
            $('#error-message').text('Cannot input negative quantity!');
        }
        else if(reporedtQty=="")
        {
            $("#last_reported_qty").text('');
            $("#qty_under_over_produced").text('');
            $("#current_percentage_since_last_report").text('');
            $('#production_new_current_percentage').text('');
        }
    }
}
